import { render, staticRenderFns } from "./ProductSI.vue?vue&type=template&id=6f164f60&"
import script from "./ProductSI.vue?vue&type=script&lang=js&"
export * from "./ProductSI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports